<div class="loading-spinner">
  <div class="loading-wrapper">
    <div>
      <mat-spinner color="accent"> </mat-spinner>
    </div>

    <div class="loading-message">
      <h2>
        {{ message }}
      </h2>
    </div>
  </div>
</div>
